import { EnvironmentId } from '@/react/portainer/environments/types';

import { FormControl } from '@@/form-components/FormControl';
import { FormSection } from '@@/form-components/FormSection';
import { Input } from '@@/form-components/Input';
import { InlineLoader } from '@@/InlineLoader';

import { useAMTInfo } from './queries/useAMTInfo';

interface Props {
  environmentId: EnvironmentId;
}

export function AMTInfoSection({ environmentId }: Props) {
  const amtInfoQuery = useAMTInfo(environmentId);

  if (amtInfoQuery.isLoading || !amtInfoQuery.data) {
    return (
      <div className="col-sm-12">
        <InlineLoader>Loading AMT information...</InlineLoader>
      </div>
    );
  }

  const info = amtInfoQuery.data;

  return (
    <FormSection title="Open Active Management Technology">
      <FormControl label="AMT Version" inputId="amt-version" size="medium">
        <Input
          id="amt-version"
          value={info.amt}
          disabled
          placeholder="Loading..."
          data-cy="endpoint-managementinfoVersion"
        />
      </FormControl>

      <FormControl label="UUID" inputId="amt-uuid" size="medium">
        <Input
          id="amt-uuid"
          value={info.uuid}
          disabled
          placeholder="Loading..."
          data-cy="endpoint-managementinfoUUID"
        />
      </FormControl>

      <FormControl
        label="Build Number"
        inputId="amt-build-number"
        size="medium"
      >
        <Input
          id="amt-build-number"
          value={info.buildNumber}
          disabled
          placeholder="Loading..."
          data-cy="endpoint-managementinfoBuildNumber"
        />
      </FormControl>

      <FormControl
        label="Control Mode"
        inputId="amt-control-mode"
        size="medium"
      >
        <Input
          id="amt-control-mode"
          value={info.controlMode}
          disabled
          placeholder="Loading..."
          data-cy="endpoint-managementinfoControlMode"
        />
      </FormControl>

      <FormControl label="DNS Suffix" inputId="amt-dns-suffix" size="medium">
        <Input
          id="amt-dns-suffix"
          value={info.dnsSuffix}
          disabled
          placeholder="Loading..."
          data-cy="endpoint-managementinfoDNSSuffix"
        />
      </FormControl>
    </FormSection>
  );
}
